const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/settings${path}`, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  if (response.status === 204) return null;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.detail || 'Settings request failed');
  return payload;
};

export const fetchSlideSettings = () => request('/slides');

export const patchSlideSettings = (updates) =>
  request('/slides', { method: 'PATCH', body: JSON.stringify(updates) });

// Admin-editable default GitHub token, used by hackathon feedback evidence
// when a specific cohort week's own token (set in its Setup config) is blank.
export const fetchDefaultGithubTokenStatus = () => request('/github-token');

export const patchDefaultGithubToken = (token) =>
  request('/github-token', { method: 'PATCH', body: JSON.stringify({ token }) });
